import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterService } from 'src/app/services/router/router.service';
import { MaintenanceMenuService } from 'src/app/shared/maintenance-menu/maintenance-menu.service';
import { ToastrService } from 'ngx-toastr';
import { MessageFieldComponent } from 'src/app/shared/message-field/message-field.component';
import { UploadResultModel } from 'src/app/shared/message-field/message-field.viewmodel';
import { UpdateStoresService } from 'src/app/pages/update-stores/update-stores.service';
import { AppAuthService } from 'src/app/services/auth/app-auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-stores',
  templateUrl: './update-stores.component.html',
  styleUrls: ['./update-stores.component.scss']
})
export class UpdateStoresComponent implements OnInit {
  /* 店舗情報ファイル */ 
  private storesFile: NgxFileDropEntry;
  /* 表示コンテンツ */ 
  public viewContent: string = 'view/download';
  /* 拡張子 */ 
  public allowedExtension = ".xlsx"
  /* メッセージフィールド */ 
  @ViewChild('messageField') private messageField: MessageFieldComponent;
  /**
   * コンストラクタ
   */
  constructor(
    public maintenanceMenuService: MaintenanceMenuService,
    private routerService: RouterService,
    private toastr: ToastrService,
    private updateStoresService: UpdateStoresService,
    private appAuthService: AppAuthService) {}

  /**
   * 初期化処理
   */
  ngOnInit(): void {
    this.routerService.setPreviousPage();
  }

  /**
   * 店舗情報ファイル取得
   */
   public setStoresFile(file: NgxFileDropEntry) {
    // エクセルファイル未選択
    if(file !== null && !file.relativePath.endsWith(this.allowedExtension)){
      this.toastr.error("Excelファイル以外が選択されています。ファイルを再選択してください", "Excelファイル非選択");
      return;
    };
    this.storesFile = file;
  }

  /**
   * 店舗情報ファイルアップロード処理
   */
  public uploadStoresFile() {
    // ファイル未選択
    if(!this.storesFile || !this.storesFile.fileEntry.isFile){
      this.toastr.error('店舗情報ファイルが選択されていません。', '店舗情報ファイル未選択');
      return;
    }

    const formData = new FormData();
    formData.append('organization', environment.organization);
    const fileEntry = this.storesFile.fileEntry as FileSystemFileEntry;
    fileEntry.file((file: File) => {
      formData.append('file', file, this.storesFile.relativePath);
      // 店舗情報ファイル取り込みAPI呼び出し
      this.updateStoresService.exportStores(formData).subscribe((res: UploadResultModel) => {
        this.messageField.pushMessage(res);
        // エラーあり
        if(res.errorCount > 0){
          this.toastr.error('店舗情報のアップロードに失敗しました', 'アップロード失敗');
        }
        // 警告あり
        else if(res.warningCount > 0){
          this.toastr.warning('店舗情報のアップロードで警告があります', 'アップロード警告');
        }
        // 正常終了
        else{
          this.toastr.info('店舗情報のアップロードが完了しました', 'アップロード完了');
        }
      }) 
    });
  }
}
